import { useAtomValue } from "@effect/atom-react";
import { rpcEffectCaller } from "@crm/rpc-client";
import { ReviewCoursesRpc } from "@crm/rpc-contract/groups/review-courses";
import { queryAtomEffect } from "@crm/shared/query-atom/effect";
import type { GetReviewResourcesInput } from "../../domain/review-course-inputs";

// 类型化 RPC Effect 调用器（错误通道保留）
const reviewCoursesRpc = rpcEffectCaller(ReviewCoursesRpc);

/**
 * Hook: Get review resources with optional courseId filter
 *
 * @param filters - 可选过滤条件（courseId）
 */
const reviewResourcesAtom = queryAtomEffect(
  (key: readonly [GetReviewResourcesInput | undefined]) =>
    reviewCoursesRpc.getReviewResources(key[0] ?? {}),
  { staleTime: 5 * 60 * 1000, reactivityKeys: ["reviewResource"] }, // 5 分钟
);

export function useReviewResources(filters?: GetReviewResourcesInput) {
  return useAtomValue(reviewResourcesAtom([filters]));
}
